import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { AuthService } from './services/auth.service';
import { HttpConfigInterceptor } from './helpers/intercepter';
import { DataLayerService } from './services/data-layer.service';
import { ToastComponent } from './shared_components/toast/toast.component';
import { ReversePipe } from './helpers/reverse-pipe';
import { ToastService } from './services/toast.service';
import { SessionStateService } from './services/session-state.service';
import { UserService } from './services/user.service';
// import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { AuthGuard } from './auth.guard';
import { AutoLogoutService } from './services/auto-logout.service';
import { SpinnerService } from './services/loader.service';
import { FloatButtonComponent } from './float-button/float-button.component';
import { NativeAPIService } from './services/native-api.service';
import { CallbackComponent } from './modules/callback/callback.component';

declare global {
  interface Window {
    webengage?: any;
  }
}
// let googleToken = window.location.origin.indexOf('www') > 0 ? '703592425609-eqv3hukq3p9pvka7kftt8eim8e562i4p.apps.googleusercontent.com' : '888147929764-gmj5i2feqc4q7ugebnq4c8ufg9uoeds2.apps.googleusercontent.com';
let googleToken = window.location.origin.indexOf('www') > 0
  ? '888147929764-gmj5i2feqc4q7ugebnq4c8ufg9uoeds2.apps.googleusercontent.com'
  : '888147929764-gmj5i2feqc4q7ugebnq4c8ufg9uoeds2.apps.googleusercontent.com';

// const config = new AuthServiceConfig([
//   {
//     id: GoogleLoginProvider.PROVIDER_ID,
//     provider: new GoogleLoginProvider(googleToken)
//   }
// ]);

// const config = {
//   autoLogin: false,
//   providers: [
//     {
//       id: GoogleLoginProvider.PROVIDER_ID,
//       provider: new GoogleLoginProvider(googleToken)
//     }
//   ]
// };

// export function provideConfig() {
//   return config;
// }

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent,
    ReversePipe,
    FloatButtonComponent,
    CallbackComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    // SocialLoginModule
  ],
  providers: [
    NativeAPIService,
    // {
    //   provide: 'SocialAuthServiceConfig',
    //   useValue: config as SocialAuthServiceConfig
    // },
    DataLayerService,
    UserService,
    SpinnerService,
    AuthService,
    AuthGuard,
    AutoLogoutService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    ToastService,
    SessionStateService
  ],  
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private router: Router, private session: SessionStateService, private service: UserService, private auth: AuthService,private spinnerService:SpinnerService) {
    this.router.events.subscribe(state => {

      let loader = document.querySelector("#universal_loader") as HTMLElement;
      this.spinnerService.hide();      
      switch (true) {
        case state instanceof NavigationStart: {
          if (!this.session.getToken()) {
            this.auth.resovleToken();
          }
          this.spinnerService.show();
          break;
        }
        case state instanceof NavigationEnd: {
          this.spinnerService.show();

          this.session.checkForSource();
          if (sessionStorage["source"] && sessionStorage["source"] != "null") {
            this.service.GetFrenchiseLogo().subscribe(resp => {
              this.spinnerService.hide();
            }, err => {
              this.spinnerService.hide();
              sessionStorage.removeItem("source");
            })
          } else {
            this.spinnerService.hide();
            sessionStorage.removeItem("source");
          }
          break;
        }
        default: {
          break;
        };
      }
    })
  }
}
